export default {
  fixedLayout: false,
  hideLogoOnMobile: false,
  serverURIOffer :'https://fx2mippbmg.execute-api.us-east-2.amazonaws.com', //prod
  //serverURIOffer :'https://4qh0y4w63g.execute-api.us-east-2.amazonaws.com', //test

  keyApiOffer :'dL0UCn8e32alCfZ9dAoqe9ibud9uHqwm63vUFXAO', //prod
  //keyApiOffer :'IEylQO9B0V42WTGxwD6PS9U1jhsNxvMk2OFX8kUa', //test

  serverURISearchOffer :'https://ilengiavg0.execute-api.us-east-2.amazonaws.com',
  keyApiSearchOffer :'UGnHXKEKVa2b4RIIjuliD1bI5NiPY3ep42fygmzU',
  serverURIPlanUsers :'https://08lpvq7uak.execute-api.us-east-2.amazonaws.com',
  keyApiPlanUsers :'RisQNutvoR6ijMdSVMF4Y90LNlp8Cz8A6bbvdAIl',
  mode : 2, // 1: versión oficial ,2 : version beta 
  mantencion:false,
}



// WEBPACK FOOTER //
// ./src/config/index.js